module.exports = __webpack_public_path__ + "img/footer_hiden.e8ab7f7c.png";